<div class="main-container" *transloco="let t; read: 'demo'">

  <img src="assets/img/reelax-arrows.svg?v=1" class="reelax-arrows" alt="Reelax Tickets">

  <div class="page-container">
    <h1 class="title --page">
      <span class="reelax-gradient">{{ t('protect') }}</span> {{ t('yourFansWithBest') }} <span class="reelax-gradient">{{ t('legaleResale') }}</span>
    </h1>

    <div class="small-container">
      <mat-card class="mt-3">
        <mat-card-content class="p-0">
          <mat-tab-group>
            <mat-tab [label]="t('demoRequest')">
              <form [formGroup]="demoForm" #demoFormDir="ngForm" class="form" (ngSubmit)="sendDemoRequest()">
                <app-text-form-field
                  class="form__field --full"
                  [controlName]="'fullName'"
                  [form]="demoForm"
                  [formModel]="demoModel"
                  [validators]="['required', 'pattern']"
                  [options]="{
                    label: t('lastAndFirstNames'),
                    pattern: nameRegex,
                    trim: true,
                  }"
                />

                <app-text-form-field
                  class="form__field --full"
                  [controlName]="'organization'"
                  [form]="demoForm"
                  [formModel]="demoModel"
                  [validators]="['required']"
                  [options]="{
                    label: t('organization'),
                    trim: true,
                  }"
                />

                <app-text-form-field
                  class="form__field --full"
                  [controlName]="'email'"
                  [form]="demoForm"
                  [formModel]="demoModel"
                  [validators]="['required', 'email']"
                  [options]="{
                    label: 'Email',
                    trim: true,
                  }"
                />

                <p class="my-3">{{ t('phoneNumber') }} ({{t('optional')}})</p>
                <app-phone-form-field
                  class="form__field --full mb-4"
                  [controlName]="'phone'"
                  [form]="demoForm"
                  [formModel]="demoModel"
                  [validators]="[]"
                  [options]="{
                    label: 'accountInfos.mobilePhone'
                  }"
                >
                </app-phone-form-field>

                <div class="buttons-group --row --centered">
                  <button mat-button type="submit" class="button --small --primary" [disabled]="!demoForm.valid">
                    <mat-icon class="button__icon">send</mat-icon>
                    <span>{{ 'button.send' | transloco }}</span>
                  </button>
                </div>
              </form>
            </mat-tab>
              
            <mat-tab [label]="t('askForACall')">
              <form [formGroup]="callForm" #callFormDir="ngForm" class="form" (ngSubmit)="sendCallRequest()">
                <p class="fw-600">
                  {{ t('letsCallToday') }}
                </p>
                <p class="fs-14">
                  {{ t('workingHours')}}<br>
                  {{ t('leaveYourNumber') }}
                </p>

                <app-text-form-field
                  class="form__field --full"
                  [controlName]="'organization'"
                  [form]="callForm"
                  [formModel]="demoModel"
                  [validators]="['required']"
                  [options]="{
                    label: t('organization'),
                    trim: true,
                  }"
                />

                <p class="my-3">{{ t('phoneNumber') }}</p>
                <app-phone-form-field
                  class="form__field --full mb-4"
                  [controlName]="'phone'"
                  [form]="callForm"
                  [formModel]="demoModel"
                  [validators]="['required']"
                  [options]="{
                    label: 'accountInfos.mobilePhone'
                  }"
                >
                </app-phone-form-field>

                <div class="buttons-group --row --centered">
                  <button mat-button type="submit" class="button --small --primary" [disabled]="!callForm.valid">
                    <mat-icon class="button__icon">send</mat-icon>
                    <span>{{ 'button.send' | transloco }}</span>
                  </button>
                </div>
              </form>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="partners">
      <h3 class="partners__title">
        {{ t('theyAlreadyTrustUs') }}
      </h3>
    </div>
  </div>
  <app-all-organizers-carousel/>
</div>
